import { SELECIONAR_DATA_VOLTA } from '../../actions/types'

const initialState = undefined

export default function reducerSelecionarDataVolta (state = null, action = initialState) {
  switch (action.type) {
    case SELECIONAR_DATA_VOLTA: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
